import React from "react";
import { Image } from "../../../core";
import { useNavigate } from "react-router-dom";
import NotificationIcon from "../../../shared/NotificationIcon";
import { useUserData } from "../../../../contexts/UserDataContext";
type Props = {
  onClickMenu: VoidFunction;
  titlePage?: string;
};

export default function Header({ onClickMenu, titlePage }: any) {
  const { profile, tokens } = useUserData();

  const navigate = useNavigate();
  return (
    <header className="flex z-10 flex-col transition-all duration-300 w-full ~gap-0.5/6">
      <div className="flex px-5 h-[75px] justify-between items-center w-full my-5 py-3 bg-white rounded-[10px]">
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => navigate("/profile")}
        >
          <Image
            src="/icons/profile.svg"
            alt="profile"
            className="bg-gray-50 p-3 rounded-full"
          />
          <div className="flex flex-col">
            <p className="text-BodyText/14/Light text-gray-950">
              {profile?.first_name} {profile?.last_name}
            </p>
            <p className="text-BodyText/12/Light text-gray-100">
              {profile?.email}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4 max-sm:gap-2 max-sm:flex-row-reverse">
          <NotificationIcon className="flex-shrink-0" />

          <div
            className="flex items-center gap-2 cursor-pointer max-sm:hidden"
            onClick={() => navigate("/support")}
          >
            <Image src="/icons/ticketing.svg" alt="ticketing" />
            <p className="text-BodyText/16/Light text-gray-900 max-sm:hidden">
              پشتیبانی
            </p>
          </div>
        </div>
      </div>
      <div className="flex gap-0.5 items-center mb-3">
        <Image src="/icons/calendar.svg" alt="calendar" width={24} />
        {(() => {
          const monthNames = [
            "فروردین",
            "اردیبهشت",
            "خرداد",
            "تیر",
            "مرداد",
            "شهریور",
            "مهر",
            "آبان",
            "آذر",
            "دی",
            "بهمن",
            "اسفند",
          ];

          function toJalali(gY: number, gM: number, gD: number) {
            // gM is 1-based, so January = 1
            var g_days_in_month = [
              31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
            ];
            var j_days_in_month = [
              31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29,
            ];

            var gy = gY - 1600;
            var gm = gM - 1;
            var gd = gD - 1;

            var g_day_no =
              365 * gy +
              Math.floor((gy + 3) / 4) -
              Math.floor((gy + 99) / 100) +
              Math.floor((gy + 399) / 400);

            for (var i = 0; i < gm; ++i) g_day_no += g_days_in_month[i];
            if (gm > 1 && ((gY % 4 == 0 && gY % 100 != 0) || gY % 400 == 0))
              ++g_day_no;
            g_day_no += gd;

            var j_day_no = g_day_no - 79;

            var j_np = Math.floor(j_day_no / 12053);
            j_day_no = j_day_no % 12053;

            var jy = 979 + 33 * j_np + 4 * Math.floor(j_day_no / 1461);

            j_day_no %= 1461;

            if (j_day_no >= 366) {
              jy += Math.floor((j_day_no - 1) / 365);
              j_day_no = (j_day_no - 1) % 365;
            }

            for (var jm = 0; jm < 11 && j_day_no >= j_days_in_month[jm]; ++jm) {
              j_day_no -= j_days_in_month[jm];
            }
            var jd = j_day_no + 1;

            return [jy, jm + 1, jd];
          }

          const now = new Date();
          const [jy, jm, jd] = toJalali(
            now.getFullYear(),
            now.getMonth() + 1,
            now.getDate()
          );
          return (
            <span className="text-BodyText/14/Light text-gray-700">
              {jd} {monthNames[jm - 1]} {jy}
            </span>
          );
        })()}
      </div>
    </header>
  );
}
